import { HOME_SERVICES_DATA } from "../../constant/CompanyData";
import Eyebrow from "../common/Eyebrow";
import Reveal from "../common/Reveal";

const HomeService = () => {
  return (
    <section className="bg-slate-50 px-6 py-20">
      <div className="mx-auto max-w-6xl">
        <div className="text-center">
          <Eyebrow>What we deliver</Eyebrow>
        </div>
        <h2 className="mx-auto mt-3 max-w-3xl text-center text-3xl font-bold tracking-tight text-[var(--website-primary-color)] md:text-4xl">
          Core solutions for enterprise infrastructure
        </h2>

        <p className="mx-auto mt-4 max-w-3xl text-center leading-relaxed text-slate-600">
          QuantaRock delivers secure colocation, cloud hosting, managed IT services, and compliance support designed for businesses that need reliable infrastructure and fast time to value.
        </p>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {HOME_SERVICES_DATA.map((service, index) => (
            <Reveal
              key={index}
              direction={index % 2 === 0 ? "left" : "right"}
              delay={(index % 3) * 0.1}
              className="h-full"
            >
              <div className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition duration-300 hover:-translate-y-1 hover:border-[rgba(var(--website-secondary-rgb),0.6)] hover:shadow-lg">
                <div className="flex h-44 items-center justify-center bg-slate-100 p-6">
                  <img
                    src={require(`../../assets/HomeServices/${service.image}`)}
                    alt={service.title}
                    className="max-h-full max-w-full object-contain transition duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-6">
                  <h3 className="text-lg font-semibold text-[var(--website-primary-color)]">
                    {service.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-600">
                    {service.description}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeService;
